import { Box } from "@mui/material";
import { v2 } from "../ui/v2Tokens";

type Props = {
  /** absent means visible — see `isNoteVisible` */
  visible?: boolean;
  onChange: (visible: boolean) => void;
  /** what the trainee would be shown it beside, e.g. "בארוחה" */
  label: string;
  ariaLabel: string;
};

/**
 * Whether a note reaches the trainee.
 *
 * Most notes are written for them, so this is checked by default and the field it drives
 * stores only the exception. The case it exists for is the other kind: a trainer's own
 * reminder about a trainee — why a meal is built the way it is, what to try next block —
 * which they were previously forced either to publish or to keep somewhere else entirely.
 *
 * Deliberately worded as what the trainee gets rather than as a "private" flag: the
 * consequence a trainer needs to see is who reads it, not what it is called.
 */
const NoteVisibility = ({ visible, onChange, label, ariaLabel }: Props) => {
  const on = visible !== false;

  return (
    <Box
      component="label"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        marginTop: "9px",
        fontSize: "12.5px",
        color: on ? v2.ink2 : v2.ink4,
        cursor: "pointer",
      }}
    >
      <Box
        component="input"
        type="checkbox"
        aria-label={ariaLabel}
        checked={on}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
        sx={{ width: "16px", height: "16px", accentColor: v2.brand, cursor: "pointer", margin: 0 }}
      />
      {on ? label : "לא מוצגת למתאמן — הערה שלך בלבד"}
    </Box>
  );
};

export default NoteVisibility;
